import styles from "./styles.module.css"
import { useState } from "react";

import { IoCreateOutline } from "react-icons/io5";
import ModalCreateUpdateQuestion from "../ModalCreateUpdateCategory";

export default function CategoryUpdateButton({ collectionRef, categoryData, updateTableData }) {
    const [modal, setModal] = useState(false);

    return (<>
        <button title="Atualizar" onClick={() => { setModal(true) }} className={styles.updateButton}>
            <IoCreateOutline />
        </button>

        {modal && <ModalCreateUpdateQuestion updateTableData={updateTableData} setModal={setModal} collectionRef={collectionRef} categoryData={categoryData} update={true} />}
    </>

    );
}